import service from "./FetchInterceptor";

async function ServerAPIService(method, endpoint, data) {
    try {
        let response;
        if (method === "GET") {
            response = await service.get(endpoint, {params: data}).then(response => {
                return response
            }).catch(error => {
                console.error('Caught in .catch:', error);
            });
        } else if (method === "SHOW") {
            response = await service.get(`${endpoint}/${data.id}`, {params: data})
                .then(response => {
                    return response
                })
                .catch(error => {
                    console.error('Caught in .catch:', error);
                });
        } else if (method === "POST") {
            response = await service.post(endpoint, data).then(response => {
                return response
            }).catch(error => {
                console.error('Caught in .catch:', error);
            });
        } else if (method === "PUT") {
            response = await service.put(endpoint, data).then(response => {
                return response
            }).catch(error => {
                console.error('Caught in .catch:', error);
            });
        } else if (method === "DELETE") {
            response = await service.delete(endpoint, {params: data}).then(response => {
                return response
            }).catch(error => {
                console.error('Caught in .catch:', error);
            });
        } else if (method === "DOWNLOAD") {
            response = await service.get(endpoint, {params: data, responseType: 'blob'})
                .then(response => {
                    return response
                })
                .catch(error => {
                    console.error('Caught in .catch:', error);
                });
        }

        return response;
    } catch (error) {
        console.log("Error:", error);
    }
}

export default ServerAPIService;
